import { useEffect } from 'react';

interface UsePushNotificationArgs {
  icon?: string;
}

export function usePushNotification({ icon }: UsePushNotificationArgs = {}) {
  useEffect(() => {
    if (typeof window === 'undefined' || !icon) return;

    const getRegistration = async () => {
      if ('serviceWorker' in navigator) {
        try {
          const registration = await navigator.serviceWorker.getRegistration();
          if (registration?.active) {
            const serviceWorker = registration.active;
            serviceWorker.postMessage({
              type: 'update_icon',
              payload: { icon },
            });
          }
        } catch (err) {
          console.error('Error getting service worker registration:', err);
        }
      }
    };

    const handleControllerChange = () => {
      getRegistration();
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
    }

    getRegistration();

    return () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
      }
    };
  }, [icon]);
}
